import { ImgHTMLAttributes, forwardRef, useState } from 'react';

import { defaultImage } from '@app/assets';

interface ImageProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'onError'> {
  fallbackSrc?: string;
}

export const Image = forwardRef<HTMLImageElement, ImageProps>(
  ({ fallbackSrc = defaultImage, src, ...props }, ref) => {
    const [imgSrc, setImgSrc] = useState(src);

    return <img {...props} ref={ref} src={imgSrc} onError={() => setImgSrc(fallbackSrc)} />;
  }
);
Image.displayName = 'Image';
